import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {AuthenticationService} from '../../services/authentication.service';
import {UtilsService} from '../../services/utils.service';

@Component({
    selector: 'app-logout',
    template: '',
    styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private utilsService: UtilsService
    ) {
    }

    ngOnInit() {
        this.authenticationService.logout().subscribe(res => {
            this.router.navigate(['/login']);
        }, (error) => {
            this.utilsService.debugLog(error);
            if (error.status === 404 || error.status === 401) {
                this.router.navigate(['/login']);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/logout/logout.component.ts